module.exports = __webpack_public_path__ + "media/icons/clipboard-list-35b6f1e3.svg";